import { render, staticRenderFns } from "./ListEmptyCard.vue?vue&type=template&id=1a8b7a48&scoped=true&"
import script from "./ListEmptyCard.vue?vue&type=script&lang=js&"
export * from "./ListEmptyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b7a48",
  null
  
)

export default component.exports